import { Routes } from '@angular/router';
import { RootRoute } from "@v1/core/app/enums/root.route";
import { InitRoute } from "@v1/features/init/init-route";
import { VersionsEnum } from "@v1/shared/app/enums";
export const routes: Routes = [
  {
    path: "",
    pathMatch: "full",
    redirectTo: `/${VersionsEnum.v1}/${RootRoute.init}/${InitRoute.selectEnterprise}`,
  },
  {
    path: VersionsEnum.v1,
    children: [
      {
        path: RootRoute.auth,
        data: {
          title: "Autenticación",
          breadcrumb: {
            label: "Inicio",
            info: "pi pi-home",
          },
        },
        loadChildren: () =>
          import("./v1/features/auth/auth.routes").then((r) => r.AuthRoutes),
      },
      {
        path: RootRoute.init,
        data: {
          title: "Init",
          breadcrumb: {
            label: "Inicio",
            info: "pi pi-home",
          },
        },
        loadChildren: () =>
          import("@v1/features/init/init.routes").then((r) => r.InitRoutes),
      },
    ],
  },
];
